import { CookiePolicyModel } from "../models/CookiePolicyModel";
import { CookiePolicyAction, CookiePolicyActionTypes } from "./actionTypes";

export const cookiePolicyUpdate = (cookiePolicy: CookiePolicyModel): CookiePolicyAction => {
    return {
        type: CookiePolicyActionTypes.COOKIE_POLICY_UPDATE,
        payload: cookiePolicy
    };
}
